import { defineComponent as _defineComponent } from 'vue'
import { config } from '@/store';
import browseTop from '@/layout/components/browse-top.vue';


const __default__ = { name: 'browse' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

function context_menu() {
	config.rightSidebar = true;
}

const __returned__ = { context_menu, get config() { return config }, browseTop }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})